
<div class="container py-5">
  <h3>Ofertas</h3>
    <div class="row g-4 justify-content-center">
      @for(promotion of promotions; track promotion) {
        <div class="col-md-6 col-lg-4">
            <app-product-promotion [promotion]="promotion"></app-product-promotion>
          </div>
        }
    </div>
</div>
